import React from 'react';
import './MemberLayout.css';

const SimpleLayout = ({ children }) => {
    return <div className="simple-layout">{children}</div>;
};

export default SimpleLayout;